import { render } from "./MiniCart.vue?vue&type=template&id=21190ef2&scoped=true"
import script from "./MiniCart.js?vue&type=script&lang=js"
export * from "./MiniCart.js?vue&type=script&lang=js"

import "./MiniCart.scss?vue&type=style&index=0&id=21190ef2&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./MiniCart.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fpresentation%2Ffashion%2FHeader%2FMiniCart%2FMiniCart.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21190ef2"]])

export default __exports__